import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import PostBlock from './post_block';
import { useAuthorAvatarsFromPublication } from '../../../../hooks/useAuthorAvatarsFromPublication';

const Post = ({ publication }) => {
  const [publicationData, setPublicationData] = React.useState(null);
  const [contentData, setContentData] = React.useState(null);
  const postRef = React.useRef(null);
  const imgs_for_filters = useSelector((state) => state.others_data.imgs_for_filters);
  const authorAvatars = useAuthorAvatarsFromPublication(publication);

  React.useEffect(() => {
    if (publication) {
      setPublicationData(publication);
    }
  }, [publication]);

  React.useEffect(() => {
    if (postRef.current && publication?.eng_name) {
      const rect = postRef.current.getBoundingClientRect();
      if (rect) {
        const coordinates = {
          eng_name: publication.eng_name,
          template_name: publication.template?.template_name,
          parent_tab: publication.parent_tab,
          x: rect.left,
          y: rect.top,
          width: rect.width,
          height: rect.height,
          scrollY: window.scrollY,
          absoluteY: rect.top + window.scrollY,
        };

        if (!window.postCoordinates) {
          window.postCoordinates = {};
        }
        window.postCoordinates[publication.eng_name] = coordinates;
      }
    }
  }, [contentData, publication]);

  React.useEffect(() => {
    if (!publicationData?.content) {
      setContentData(null);
      return;
    }

    try {
      const parsed =
        typeof publicationData.content === 'string'
          ? JSON.parse(publicationData.content)
          : publicationData.content;
      setContentData(Array.isArray(parsed) ? parsed : null);
    } catch {
      setContentData(null);
    }
  }, [publicationData]);

  const filterA = React.useMemo(() => {
    if (!publication?.publication_settings) return null;

    try {
      const settings = JSON.parse(publication.publication_settings);
      return settings.publication_filter_a || null;
    } catch {
      return null;
    }
  }, [publication?.publication_settings]);

  const filterB = React.useMemo(() => {
    if (!publication?.publication_settings) return null;

    try {
      const settings = JSON.parse(publication.publication_settings);
      return settings.publication_filter_b || null;
    } catch {
      return null;
    }
  }, [publication?.publication_settings]);

  const pathToFolder =
    publicationData?.path && publicationData?.eng_name
      ? `https://${publicationData.path}${publicationData.eng_name}/`
      : '';

  return (
    <div
      ref={postRef}
      className={styles.post}
      data-eng-name={publication?.eng_name}
      data-template-name={publication?.template?.template_name}
      data-parent-tab={publication?.parent_tab}>
      {contentData && Array.isArray(contentData) ? (
        <div className={styles.blocksContainer}>
          {contentData.map((block, index) => (
            <PostBlock
              key={index}
              blockData={block}
              path_to_folder={pathToFolder}
              filterA={filterA}
              filterB={filterB}
              imgs_for_filters={imgs_for_filters}
              authorAvatars={authorAvatars}
            />
          ))}
        </div>
      ) : (
        <div className={styles.noBlocksMessage}>Блоки не найдены</div>
      )}
    </div>
  );
};

export default Post;
